<template>
    <BasePanel 
        headline="lang_GENEREIC_CAPTION_PERSONS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <BaseEditDataTable 
                :headers="headers"
                :items="items"
                :alvqa="alvqa"
                :deleteFunction="deleteFunction"
                :editingFunction="editingFunction"
            >
                <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3 pt-3 pr-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>
                <!-- Cols -->
                <template v-slot:body="{ item }">
                    <td 
                        class="no_ellipsis"
                        :alvqa="alvqa + '-list-row-' + item.item.id + '-text-first-name'"
                    >
                        {{ item.item.firstName }}
                    </td>
                    <td 
                        class="no_ellipsis"
                        :alvqa="alvqa + '-list-row-' + item.item.id + '-text-last-name'"
                    >
                        {{ item.item.lastName }}
                    </td>
                    <td 
                        class="no_ellipsis"
                        :alvqa="alvqa + '-list-row-' + item.item.id + '-text-key-name'"
                    >
                        {{ item.item.gemaName }}
                    </td>
                    <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-cellphone'">
                        {{ item.item.cellphone }}
                    </td>
                    <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-email'">
                        {{ item.item.email }}
                    </td>
                    <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-role'">
                        {{ item.item.role }}
                    </td>
                    <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-inherit-from-group'">
                        {{ item.item.inheritFromGroup === 'yes' ? $t('lang_GENERAL_YES') : $t('lang_GENERAL_NO') }}
                    </td>
                </template>
            </BaseEditDataTable>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditDataTable from '@/components/_base/BaseEditDataTable'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "PersonsEditPanel",
    components: {
        BasePanel,
        BaseEditDataTable,
        BaseButton,
        BaseTooltip
    },
    data() {
        return {
            alvqa: 'az-persons-edit-panel'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_FIRST_NAME"), 
                    align: "left", 
                    value: "firstName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-first-name'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_LAST_NAME"), 
                    align: "left", 
                    value: "lastName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-last-name'
                },
                {
                    text: this.$t("lang_GENERIC_AZ_CAPTION_GEMA_NAME"), 
                    align: "left", 
                    value: "gemaName",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-key-name'
                },
                {
                    text: this.$t("lang_AZ_PERSONS_CAPTION_CELLPHONE"), 
                    align: "left", 
                    value: "cellphone",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-mobil'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_EMAIL"), 
                    align: "left", 
                    value: "email",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-email'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_ROLE"), 
                    align: "left", 
                    value: "role",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-role'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_GAI"), 
                    align: "left", 
                    value: "inheritFromGroup",
                    class: 'text-no-wrap',
                    sortable: false,
                    mouseover: this.$t('lang_AZ_GROUPS_PERSONS_CAPTION_GROUP_ADDRESS_INHERITANCE'),
                    alvqa: this.alvqa + '-header-gai'
                },
            ]
        },
        items() { return this.$store.getters.getPersonsPanelEntry },
    },
    methods: {
        addNewRow(){
            this.$store.commit('setShowEditingDialog', true) 
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultPersonsPanelEntry)) 
            this.$store.commit('setPersonsPanelEntryEditingDialogDetails', defaultValues)
        },
        deleteFunction(item) {
            this.$store.commit('setSelectedPersonsPanelEntry', item.id)
            this.$store.commit('setDeletionDialogContext', 'SelectedPersonsPanelEntry')
            this.$store.commit('setShowDeletionDialog', true)
        },
        editingFunction(item) {
            this.$store.commit('setSelectedPersonsPanelEntry', item.id)
            this.$store.commit('setPersonsPanelEntryDetailsPerson', item)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            this.$store.commit('setPersonsPanelEntryEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowEditingDialog', true) 
        }
    }
}
</script>